import React from "react";
import PropTypes from "prop-types";
import { Button, Col, Modal, ModalBody, ModalFooter, Row } from "reactstrap";
import styled from "styled-components";
import "flatpickr/dist/themes/material_blue.css";
import { AvForm } from "availity-reactstrap-validation";
// import CustomPlanItem from "./CustomPlanItem";
import CustomMiniLoader from "../../../components/CustomMiniLoader/CustomMiniLoader";
import { showInfoMessage } from "../../../helpers/utils";
import EditVoucherItems from "./EditVoucherItems";

const EditVoucherModal = ({
  isOpen,
  toggle,
  editData,
  permissions,
  mediaBuyerVoucherUpdateTrigger,
  loader,
  data,
  dateRange
}) => {
  const [isFormSubmit, setIsFormSubmit] = React.useState(false);

  const generateKey = () => Math.round(Math.random() * 10000).toString();
  const [groups, setGroups] = React.useState([]);

  const handleAddGroup = () => {
    if (groups.length <= 31) {
      setGroups(prev => [
        ...prev,
        {
          id: "",
          key: generateKey(),
          date: "",
          voucher: "",
        },
      ]);
    } else {
      showInfoMessage("Added max fields");
    }
  };

  const handleDeleteGroup = key => {
    setGroups(prev => prev.filter(i => i.key !== key));
  };

  React.useEffect(() => {
    return () => {
      setGroups([]);
    };
  }, []);

  const onCloseToggle = React.useMemo(() => {
    if (loader) return toggle();
  }, [loader]);

  React.useEffect(() => {
    if (data.length > 0) {
      let customs = [];
      data.map(i => {
        customs.push({
          key: generateKey(),
          voucher: i?.amount,
          date: i.date,
          id: i.id,
        });
      });
      setGroups(customs);
    }
  }, [data]);

  const onSubmit = (e, errors, params) => {
    setIsFormSubmit(true);
    let filtersData = {};

    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_admin"] ||
      permissions["is_viewer"] ||
      permissions["is_hr"]
    ) {
      filtersData = {
        for_yourself: false,
        ...dateRange,
      }
    } else {
      filtersData = {
        for_yourself: true,
        ...dateRange,
      }
    }

    if (errors?.length === 0) {
      const items = {
        items: [],
        patch: [],
        add: [],
        drop: [],
        filters: filtersData,
      };

      if (groups.length > 0) {
        for (const key in params) {
          const split = key.split("|");
          if (split.length === 2) {
            const k = split[0];
            let suffix = items.items.find(i => i.key === split[1])?.key;
            if (suffix !== undefined) {
              let idx = items.items.findIndex(i => i.key === suffix);
              items.items[idx][k] = params[key];
            } else {
              items.items.push({
                key: split[1],
                [k]: params[key],
              });
            }
          }
        }

        if (data.length > 0) {
          items.items.map(i => {
            data.map(current => {
              let find = items.items.findIndex(i => i.id == current.id);
              if (find < 0) {
                items.drop.push(current.id);
              }
            });

            if (i?.id) {
              items.patch.push({
                id: i.id,
                voucher: i?.voucher,
                date: i.date,
                offer_name: i.offer_name,
                media_buyer: i.media_buyer,
              });

            } else {
              items.add.push({
                voucher: i?.voucher,
                date: i.date,
                offer_name: i.offer_name,
                media_buyer: i.media_buyer,
              });

            }
          });
          mediaBuyerVoucherUpdateTrigger(items);
          toggle();

        } else {
          items.items.map(i => {
            items.add.push({
              voucher: i?.voucher,
              date: i.date,
              offer_name: i.offer_name,
              media_buyer: i.media_buyer,
            });
          });

          mediaBuyerVoucherUpdateTrigger(items);
          toggle();

        }
      } else {
        data.map(current => {
          let find = items.items.findIndex(i => i.id == current.id);
          if (find < 0) {
            items.drop.push(current.id);
            current.cashback?.id &&
              items.cashback.drop.push(current.cashback?.id);
          }
          mediaBuyerVoucherUpdateTrigger(items);
          toggle();
        });
      }
    }
  };

  return (
    <ModalStyle
      isOpen={isOpen}
      autoFocus={true}
      centered={true}
      size="md"
      toggle={toggle}
    >
      {() => onCloseToggle()}
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          Edit {editData?.offer_name}
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col md={12}>
              <Row className="m-0">
                <div className="text-end p-0 mb-3 mt-3">
                  <Button color="primary" onClick={handleAddGroup}>
                    <i className="mdi mdi-plus" /> Add voucher
                  </Button>
                </div>
              </Row>
              <StyledScroll params={groups.length}>
                {groups.length > 0 ? (
                  groups.map((i, idx) => (
                    <EditVoucherItems
                      key={idx}
                      num={groups.length}
                      keys={i.key}
                      items={i}
                      fixedData={{
                        offer_name: editData.offer_name,
                        media_buyer: editData.media_buyer
                      }}
                      onDelete={() => handleDeleteGroup(i.key)}
                    />
                  ))
                ) : (
                  <Row className="align-items-center text-center mt-4">
                    <Col xs={12}>
                      <i
                        className="dripicons-archive"
                        style={{ fontSize: "40px", opacity: "0.2" }}
                      />
                      <p style={{ opacity: "0.2" }}>Empty...</p>
                    </Col>
                  </Row>
                )}
              </StyledScroll>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <Button
                  color="primary"
                  style={{
                    padding: "10px",
                    minWidth: "74px",
                    marginRight: 10,
                    display: loader ? "none" : "",
                  }}
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                >
                  Close
                </Button>
                {permissions?.["change_managerplanmodel"] && (
                  <>
                    {loader ? (
                      <CustomMiniLoader
                        style={{ padding: "10px", minWidth: "143px" }}
                        status
                        text="Please wait"
                      />
                    ) : (
                      <Button
                        color="success"
                        style={{ padding: "10px", minWidth: "143px" }}
                      >
                        Save changes
                      </Button>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </ModalStyle>
  );
};

const ModalStyle = styled(Modal)`
  position: relative;

  .modal-header {
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
  }

  .row-with-sticky {
    position: sticky;
    top: 61px;
    background: #fff;
    z-index: 1;
    border-bottom: 1px solid #eff2f7;
    margin: 0 0 20px 0;
  }
`;

const StyledScroll = styled.div`
  @media (max-width: 768px) {
  }
`;

EditVoucherModal.propTypes = {
  editData: PropTypes.any,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  data: PropTypes.any,
  loader: PropTypes.bool,
  mediaBuyerVoucherUpdateTrigger: PropTypes.func.isRequired,
  dateRange: PropTypes.object,
};

export default EditVoucherModal;
